import { computed, inject, Injectable, Injector, signal } from '@angular/core';
import { OshDTO } from '@app/shared/services/dtos/osh/osh.dto';
import { UsersDataService } from '@app/shared/services/users-data.service';
import { Osh } from '@app/shared/types/models/osh/osh.model';
import { AbstractFactory } from './abstract.factory';

@Injectable({ providedIn: 'root' })
export class OshAnalysisFactory extends AbstractFactory<OshDTO, Osh> {
  private readonly injector: Injector = inject(Injector);
  private readonly usersService: UsersDataService = this.injector.get<UsersDataService>(UsersDataService);

  public constructor() {
    super();
  }

  public produce(item: OshDTO): Osh {
    return item
      ? new Osh({
          assignedUsers:
            (item.assignedUsers?.length ?? 0)
              ? computed(() => item.assignedUsers.map(user => this.usersService.getById(user.id)()))
              : signal([]),
          companyId: item.companyId,
          dangerousSituations: item.dangerousSituations,
          id: item.id,
          parentId: item.parentId,
          path: item.path,
          projectId: item.projectId,
          sequence: item.sequence,
          taskId: item.taskId,
          workDescription: item.workDescription,
          workPossibleThreat: item.workPossibleThreat,
          workStartDate: item.workStartDate,
          workType: item.workType
        })
      : undefined;
  }
}
